export default __webpack_public_path__ + "static/media/report-bg-l.c04d40d1.png";